import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { showToast } from '../../../../../../core/utils/alert';
import { useRazorpayPayment } from '../hooks/useRazorpayPayment';
import { all_routes } from '../../../../../router/all_routes';

const PaymentDetails = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { student, invoice, totalAmount } = location.state;
    const [payableAmount, setPayableAmount] = useState(totalAmount);
    const { startPayment, isCreating } = useRazorpayPayment();

    const handlePay = () => {
        const payload = {
            center_id: student.center.id,
            student_id: student.id,
            amount: payableAmount,
            invoice_id: invoice,
            studentName: student.first_name + " " + student.last_name,
            studentEmail: student.profile.email,
            studentPhone: student.profile.phone.toString(),
            onSuccess: (result: any) => {
                showToast({
                    title: "Success",
                    text: result.message || "Payment successful!",
                    icon: "success",
                });
                navigate(all_routes.studentFees
                    .replace(":id", student.id || "")
                    .replace(":studentId", student.id.toString()));
            },
            onError: (err: any) => {
                showToast({
                    title: "Error",
                    text: "Payment failed or cancelled.",
                    icon: "error",
                });
                console.log("Error:--> ", err);
            },
        };

        startPayment(payload);
    };

    const isAmountValid = payableAmount > 0 && payableAmount <= totalAmount;

    return (
        <div className="page-wrapper bg-light">
            <div className="content container py-4">
                <div className="row justify-content-center">
                    <div className="col-xxl-8 col-xl-9 col-lg-10">
                        <div className="card border-0 shadow-sm">
                            <div className="card-header bg-primary text-white py-3">
                                <h4 className="mb-0 text-center text-white">
                                    <i className="fas fa-calculator me-2"></i>Payment Details
                                </h4>
                            </div>
                            <div className="card-body p-4">
                                <div className="row mb-4">
                                    <div className="col-md-6">
                                        <h5 className="text-primary mb-3">Student Details</h5>
                                        <p><strong>Name:</strong> {student.first_name} {student.last_name}</p>
                                        <p><strong>Email:</strong> {student.profile.email}</p>
                                        <p><strong>Phone:</strong> +91 {student.profile.phone}</p>
                                    </div>
                                    <div className="col-md-6">
                                        <h5 className="text-primary mb-3">Invoice Details</h5>
                                        {/* <p><strong>Invoice Numbers:</strong> {invoices.map((inv:any) => `INV-${inv}`).join(', ')}</p> */}
                                        <p><strong>Invoice Number:</strong> {`INV-${invoice}`}</p>
                                        <p><strong>Total Amount:</strong> <span className="text-success">₹{totalAmount}</span></p>
                                    </div>
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="payableAmount" className="form-label fw-bold">Enter Amount to Pay</label>
                                    <input
                                        id="payableAmount"
                                        type="number"
                                        value={payableAmount}
                                        onChange={(e) => setPayableAmount(Number(e.target.value))}
                                        className={`form-control ${!isAmountValid ? 'is-invalid' : ''}`}
                                    />
                                    {!isAmountValid && (
                                        <div className="invalid-feedback d-block">
                                            Amount must be greater than 0 and less than or equal to ₹{totalAmount}.
                                        </div>
                                    )}
                                </div>

                                <div className="d-flex justify-content-between">
                                    <button 
                                        className="btn btn-outline-secondary"
                                        onClick={() => navigate(-1)}
                                    >
                                        <i className="fas fa-arrow-left me-2"></i>Back
                                    </button>
                                    <button 
                                        onClick={handlePay} 
                                        className="btn btn-primary px-4 py-2"
                                        disabled={isCreating || !isAmountValid}
                                    >
                                        {isCreating ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                Processing...
                                            </>
                                        ) : (
                                            <>
                                                <i className="fas fa-credit-card me-2"></i>Pay Now
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                            <div className="card-footer bg-white text-center py-3 border-top">
                                <small className="text-muted">
                                    <i className="fas fa-lock me-1"></i>Your payment information is secure and encrypted
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentDetails;